import React from "react";
import { Card, CardContent } from "../ui/card";
import { ScrollArea } from "../ui/scroll-area";


const Terms = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 p-6 sm:p-12">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-indigo-700 mb-6">Quizora - Terms & Conditions</h1>
        <p className="text-sm text-gray-600 mb-2">
          Effective Date: {new Date().toLocaleDateString("en-IN", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })}
        </p>


        <Card className="shadow-lg">
          <ScrollArea className="h-[70vh] p-6">
            <CardContent className="space-y-5">
              <p>
                By using the Quizora platform ("Website"), you agree to be bound by these Terms and
                Conditions. Please read them carefully.
              </p>

              <section>
                <h2 className="font-semibold text-lg text-indigo-600">1. Eligibility</h2>
                <ul className="list-disc ml-5">
                  <li>Users must be 18 years of age or older or have parental/guardian consent to participate.</li>
                  <li>One account per participant is allowed. Duplicate accounts will be disqualified.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-semibold text-lg text-indigo-600">2. Registration</h2>
                <ul className="list-disc ml-5">
                  <li>All users must register with a valid email address and mobile number.</li>
                  <li>OTP verification is mandatory for account creation and login.</li>
                  <li>Quizora reserves the right to reject any registration found suspicious.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-semibold text-lg text-indigo-600">3. Event Participation</h2>
                <ul className="list-disc ml-5">
                  <li>Participants must pay a non-refundable entry fee of ₹65 per event.</li>
                  <li>Each event is limited to 3,000 participants.</li>
                  <li>Upon successful payment, users will receive a hall ticket number.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-semibold text-lg text-indigo-600">4. Exam Format</h2>
                <ul className="list-disc ml-5">
                  <li>Each exam will consist of 30 aptitude questions.</li>
                  <li>Total time: 900 seconds (15 minutes).</li>
                  <li>Scoring: +1 for correct answers, -0.50 for incorrect answers.</li>
                  <li>Ranking is based on highest score and least time taken.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-semibold text-lg text-indigo-600">5. Prizes</h2>
                <ul className="list-disc ml-5">
                  <li>Top 3 scorers in each event will receive prize money.</li>
                  <li>Prizes will be credited within 7 business days.</li>
                  <li>In case of tie, the faster participant will be ranked higher.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-semibold text-lg text-indigo-600">6. Code of Conduct</h2>
                <ul className="list-disc ml-5">
                  <li>No cheating, bot usage, or unfair practices allowed.</li>
                  <li>Violation results in disqualification and account ban.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-semibold text-lg text-indigo-600">7. Technical Requirements</h2>
                <ul className="list-disc ml-5">
                  <li>Participants must ensure stable internet connectivity.</li>
                  <li>Quizora is not liable for participant-side technical issues.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-semibold text-lg text-indigo-600">8. Cancellation and Refund Policy</h2>
                <ul className="list-disc ml-5">
                  <li>Entry fees are non-refundable.</li>
                  <li>Events will not be rescheduled once announced.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-semibold text-lg text-indigo-600">9. Data Privacy</h2>
                <ul className="list-disc ml-5">
                  <li>User data is securely stored and used only for Quizora-related communications.</li>
                  <li>No data will be shared with third parties without consent.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-semibold text-lg text-indigo-600">10. Limitation of Liability</h2>
                <ul className="list-disc ml-5">
                  <li>Quizora is not liable for data loss, financial loss, or outages beyond control.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-semibold text-lg text-indigo-600">11. Governing Law</h2>
                <ul className="list-disc ml-5">
                  <li>These Terms are governed by Indian law and jurisdiction lies in courts of Tamil Nadu.</li>
                </ul>
              </section>

              <section>
                <h2 className="font-semibold text-lg text-indigo-600">12. Changes to Terms</h2>
                <ul className="list-disc ml-5">
                  <li>Quizora may modify terms anytime. Continued use implies acceptance.</li>
                </ul>
              </section>

              <p className="mt-6 text-sm">For queries, contact: <a href="mailto:support@quizora.in" className="text-indigo-600 underline">
                support@quizora.in
              </a>
              </p>
            </CardContent>
          </ScrollArea>
        </Card>
      </div>
    </div>
  );
};

export default Terms;